import { render } from "./InputItem.vue?vue&type=template&id=a3bad148&scoped=true"
import script from "./InputItem.vue?vue&type=script&lang=js"
export * from "./InputItem.vue?vue&type=script&lang=js"

import "./InputItem.vue?vue&type=style&index=0&id=a3bad148&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3bad148"]])

export default __exports__